// Initial State
const initialState = {
  deliveryOptions: [],
  error: null
};

// Action constants
const GET_DELIVERY_OPTIONS = 'GET_DELIVERY_OPTIONS';
const GET_DELIVERY_OPTIONS_SUCCESS = 'GET_DELIVERY_OPTIONS_SUCCESS';
const GET_DELIVERY_OPTIONS_FAILURE = 'GET_DELIVERY_OPTIONS_FAILURE';

// Action creators
export const getDeliveryOptions = () => {
  return {
    types: [GET_DELIVERY_OPTIONS, GET_DELIVERY_OPTIONS_SUCCESS, GET_DELIVERY_OPTIONS_FAILURE],
    payload: {
      request: {
        url: '/delivery-options',
        method: 'GET',
      }
    }
  };
};

const deliveryOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DELIVERY_OPTIONS_SUCCESS:
      return {
        ...state,
        deliveryOptions: action.payload?.data?.data?.sort((a, b) => a.type > b.type ? 1 : -1)
      };

    case GET_DELIVERY_OPTIONS_FAILURE:
      return {
        ...state,
        error: action.payload.data.error
      };

    default:
      return state;
  }
};

export default deliveryOptionsReducer;
